import React from 'react'
import PropTypes from 'prop-types'
import CaseContext from '../contexts/CaseContext'

function Case (props) {
  return (
    <CaseContext.Provider value={props.value}>
      <>
        {props.children}
      </>
    </CaseContext.Provider>
  )
}

Case.defaultProps = {
  value: null
}

Case.propTypes = {
  value: PropTypes.any.isRequired
}

export default Case
